import * as Net from 'util/Net';

export interface OnboardingSessionResult {
  session_id: string;
}

export interface AboutMeResponse {
  content: string | null;
}

/**
 * Start or resume the onboarding question flow for the current user.
 *
 * Creates a new onboarding session if the user has never onboarded, resumes
 * an existing session that is still waiting for answers, or creates a fresh
 * session if the previous one is already complete (restart).
 */
export function startOnboardingSession(): Promise<OnboardingSessionResult> {
  return Net.postJSONPromise({
    url: '/1/api/users/me/llm-onboarding/start',
    data: {},
  });
}

/**
 * Restart the onboarding flow for the current user.
 * Clears the existing onboarding session so the next start creates a fresh one.
 */
export async function restartOnboardingSession(): Promise<void> {
  await Net.postJSONPromise({url: '/1/api/users/me/llm-onboarding/restart', data: {}});
}

/**
 * Fetch the current user's About Me paragraph generated from the onboarding flow.
 */
export async function getUserAboutMe(): Promise<string | null> {
  const response: AboutMeResponse = await Net.getJSONPromise('/1/api/users/me/llm-onboarding/about-me');
  return response.content;
}

/**
 * Clear the current user's About Me paragraph.
 */
export async function clearUserAboutMe(): Promise<void> {
  await Net.deletePromise({url: '/1/api/users/me/llm-onboarding/about-me'});
}
